module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('main-layout', [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "grid-content bg-purple-dark"
  }, [_c('table', {
    staticClass: "ParametersFrame ParamsGrid MenuBarBkGnd",
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('table', [_c('tbody', _vm._l((this.chunkedParameters), function(chunk) {
    return _c('tr', [_vm._l((chunk), function(param) {
      return [_c('td', {
        staticClass: "ParamLabelCell"
      }, [_c('label', [_c('span', [_vm._v(_vm._s(param.Label))])])]), _vm._v(" "), _c('td', {
        staticClass: "ParamEntryCell",
        staticStyle: {
          "padding-right": "0px"
        }
      }, [_c('parameter-control', {
        attrs: {
          "parameter": param
        }
      })], 1), _vm._v(" "), _c('td', {
        staticClass: "InterParamPadding"
      })]
    })], 2)
  }))])]), _vm._v(" "), _c('td', {
    attrs: {
      "width": "6px"
    }
  }), _vm._v(" "), _c('td', {
    staticClass: "SubmitButtonCell"
  }, [_c('table', [_c('tbody', [_c('tr', [_c('td', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.viewReport()
      }
    }
  }, [_vm._v("View Report")])], 1)]), _vm._v(" "), _c('tr', [_c('td', [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.sendToMe()
      }
    }
  }, [_vm._v("Send to me")])], 1)])])])])])])])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    ref: "report",
    staticClass: "reportContainer"
  })])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-371dcd13!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ssrs.vue
// module id = 477
// module chunks = 2